import styled from '@emotion/styled'

export const Space = styled.span`
    padding-bottom: ${({ size }) => size ? `${size}rem` : '1rem' };
    display: block;
`